import { render, staticRenderFns } from "./ImpersonateHeader.vue?vue&type=template&id=0c219f1c&scoped=true"
import script from "./ImpersonateHeader.vue?vue&type=script&lang=ts"
export * from "./ImpersonateHeader.vue?vue&type=script&lang=ts"
import style0 from "./ImpersonateHeader.vue?vue&type=style&index=0&id=0c219f1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c219f1c",
  null
  
)

export default component.exports